import React, {PureComponent} from 'react';
import {connect} from 'react-redux';

import {Link, Redirect} from 'components/ReactRouterDomLocalized';

import Footer from '../components/Footer';
import FormField from '../components/registration/FormField';

import {dt, t} from '../l10n';
import {login} from '../backend-helpers/member';
import {setCurrentUser} from '../reducers/currentUser';
import {getRegions} from '../backend-helpers/misc';

import '../sass/react-tel-input.scss';
import {Helmet} from "react-helmet";
import {getFormData} from "../utils/forms";

class Login extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            formErrors: {},
        };
    }
    
    onSubmit = event => {
        event.preventDefault();
        const data = getFormData(event.target);
        login(data)
            .then(res => {
                this.onLoginSuccess(res)
            })
            .catch(error => {
                this.setState({formErrors: {password: error.message}})
            });
    }
    
    onLoginSuccess = ({user}) => {
        const {setCurrentUser} = this.props;
        setCurrentUser(user);
    }

    validateForm = data => {
        const formErrors = {};

        if (data.nick && !data.nick.length) {
            formErrors.nick = t('Nick is required')
        }

        if (data.password && !data.password.length) {
            formErrors.passwoed = t('Password is required')
        }

        return formErrors;
    };

    getRegions = country => {
        let that = this;
        getRegions(country).then(function(response) {
            that.setState({regions: response.data});
        })
    };

    componentDidMount() {
        this.getRegions("FR");
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.state.activation && this.props.currentUser.active === 0) {
            this.setState({activation: true})
        }
    }

    render() {
        const {formErrors} = this.state;
        const {currentUser} = this.props;
    
        if (currentUser.isLoggedIn()) {
            return <Redirect to="/"/>
        }

        return(
            <div id='wrapper'>
                <Helmet>
                    <title>{dt('meta', 'Login to bobTV')}</title>
                </Helmet>
                <header className='registration'>
                    <div className='content'>
                        <h1>{t('Log in')}</h1>
                        <div className='text-login'>
                            <form onSubmit={this.onSubmit}>
                                <div className='column'>
                                    <FormField error={formErrors.nick}>
                                        <label>{t('Nick:')}</label>
                                        <input type='text' name='nick'/>
                                    </FormField>
                                    <FormField error={formErrors.password}>
                                        <label>{t('Password:')}</label>
                                        <input type='password' name='password'/>
                                    </FormField>
                                </div>
                                <div style={{marginTop: '20px', display: 'block'}}>
                                    <div className="forgot">
                                        <Link to="/enregistrement" className="header-button">{t('Registration')}</Link>
                                        <Link to="/?password_recover" className="header-button">{t('Forgot password?')}</Link>
                                    </div>
                                    <div>
                                        <button type='submit' className='btn-submit'>{t('Send')}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </header>
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.currentUser
});

const mapDispatchToProps = {
    setCurrentUser
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login.js